import { STATE } from '../constants/stateClasses';
import { breakpoints } from '../utils/breakpoints';
import { debounce } from '../utils/debounce';

const selectors = {
  mapContainer: '.js-multiple-loc-leaflet-map',
  mapWrapper: '.js-multiple-loc-map-wrapper',
  locationBtn: '.js-multi-loc-map-btn',
  locationCard: '.js-multi-loc-map-info-card',
};

const ZOOM = {
  default: 13,
  active: 15,
};

const handleMulitLocContactMap = async () => {
  let initializedMaps = false;

  const mapWrapper = document.querySelector(selectors.mapWrapper);

  if (mapWrapper === null) return;

  const { default: L } = await import('leaflet');
  await import('leaflet/dist/leaflet.css');

  const initMap = (mapWrapper) => {
    if (initializedMaps === true) return;

    const mapContainer = mapWrapper.querySelector(selectors.mapContainer);
    const mapCoordinates = window.contactMapsCoordinates;
    const { coordinates } = mapCoordinates;
    let mapCenterCoordinates = null;
    let markerCoordinates = null;
    let zoom = ZOOM.default;

    // Don't create multilocation maps for mobile
    if (window.innerWidth < breakpoints.tablet) return;

    // Get coordinates of the first array element for a map with multiple locations
    const [firstLoc] = coordinates;

    const { loc_lat: lat, loc_lng: lng } = firstLoc;

    mapCenterCoordinates = [parseFloat(lat), parseFloat(lng)];
    markerCoordinates = mapCenterCoordinates;
    zoom = ZOOM.active;

    // Create map
    const map = L.map(mapContainer, {
      center: mapCenterCoordinates,
      attributionControl: false,
      zoom,
      scrollWheelZoom: false,
    });

    // Create marker options
    const markerOptions = {
      icon: new L.Icon({
        iconUrl: '/wp-content/themes/prograffing-sage-starter/public/images/svg/map-pin.svg',
        iconSize: [33, 40],
        iconAnchor: [33 * 0.5, 40],
        className: 'leaflet-custom-icon',
      }),
    };

    // Create marker
    const marker = L.marker(markerCoordinates, markerOptions);

    // Load map tile layer
    const CartoDB_Positron = L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
      subdomains: 'abcd',
      maxZoom: 20,
    });

    // Add layer to map
    CartoDB_Positron.addTo(map);

    // Add marker to map
    marker.addTo(map);

    initializedMaps = true;

    // Handle map with mulitple locations
    const locationsBtns = [...mapWrapper.querySelectorAll(selectors.locationBtn)];
    const locationsCards = [...mapWrapper.querySelectorAll(selectors.locationCard)];

    if (locationsBtns.length === 0) return;

    let prevActiveEl = locationsBtns[0];

    locationsBtns.forEach((btn, btnIndex) => {
      const { loc_lat: lat, loc_lng: lng, link } = coordinates[btnIndex];

      // Create marker
      const marker = L.marker([parseFloat(lat), parseFloat(lng)], markerOptions);

      // Add marker to map
      marker.addTo(map);

      if (link) {
        marker.addEventListener('click', () => {
          window.open(link);
        });
      }

      btn.addEventListener('mouseenter', ({ currentTarget }) => {
        // Check is it active element
        const isActive = currentTarget.classList.contains(STATE.active);

        // Update view coordinates and set the zoom depending on it's an active element or not
        map.setView([parseFloat(lat), parseFloat(lng)], isActive ? ZOOM.active : ZOOM.default);
      });

      btn.addEventListener('mouseleave', ({ currentTarget }) => {
        // If it's an active element, exit
        if (currentTarget.classList.contains(STATE.active)) return;

        // Otherwise, return to the previous active coordinates
        map.setView(mapCenterCoordinates, ZOOM.active);
      });

      btn.addEventListener('click', ({ currentTarget }) => {
        // Return if the same element was clicked twice
        if (currentTarget === prevActiveEl) return;

        // Find index of the previous element
        const prevElIndex = locationsBtns.findIndex((btn) => btn.classList.contains(STATE.active));

        // Remove active class from the previous element
        locationsBtns[prevElIndex]?.classList.remove(STATE.active);
        locationsCards[prevElIndex]?.classList.remove(STATE.active);

        // Find index of the active element
        const activeElIndex = locationsBtns.findIndex((btn) => btn === currentTarget);

        // Add active class for the current element
        locationsBtns[activeElIndex]?.classList.add(STATE.active);
        locationsCards[activeElIndex]?.classList.add(STATE.active);

        // Update global coordinates value
        mapCenterCoordinates = [parseFloat(lat), parseFloat(lng)];

        // Set zoom for active element
        map.setZoom(ZOOM.active);

        // Update prevActiveEl
        prevActiveEl = currentTarget;
      });
    });
  };

  initMap(mapWrapper);

  window.addEventListener(
    'resize',
    debounce(() => {
      initMap(mapWrapper);
    }, 300)
  );
};

export default handleMulitLocContactMap;
